import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ApiService } from 'src/app/shared/api.service';
import { Http } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Feedback } from 'src/app/model/feedback-model/feedback.model';
import { FormControl, FormGroup } from '@angular/forms';
import { PanelAsignService } from 'src/app/shared/panel-assign/panel-assign.service';
import { NotificationService } from 'src/app/shared/notification.service';

export interface DialogData {
  feedbackValue: string;
  candidateId: number;
  panelId: number;
  status: number;
}

@Component({
  selector: 'app-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss']
})
export class FeedbackModalComponent implements OnInit {
  private candidateId: number;
  private candidateArrya = [];
  private apiDomain = ApiService.getDomainName();
  private panelId: number;
  private feedback: string;
  feedbackValue: string;
  private status: number;
  private candidateFeedbackValue: string;

  public textareaForm = new FormGroup({
    feedbackValue: new FormControl()
  });



  constructor(
    private http: Http,
    private panelAsignService: PanelAsignService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<FeedbackModalComponent>,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.candidateId = data.candidateId;
    this.panelId = data.panelId;
    this.candidateArrya.push(data.candidateId);
    this.candidateFeedback(this.panelId, this.candidateId);
    this.status = data.status;
  }

  ngOnInit() {
    // this.feedback=this.textareaForm.value;
  }

  candidateFeedback(panelId, candidateId) {
    this.panelAsignService.getPanelCandidate(panelId).then(
      candidatefeedback => {
        for (let i = 0; i < candidatefeedback.length; i++) {
          if (candidatefeedback[i].candidateId === candidateId) {
            this.candidateFeedbackValue = candidatefeedback[i].feedback;
            this.data.feedbackValue = this.candidateFeedbackValue;
            this.textareaForm.controls['feedbackValue'].setValue(this.candidateFeedbackValue);
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  onClose() {
    this.dialogRef.close();
  }

  feedBackSubmit() {
    this.feedback = this.textareaForm.value.feedbackValue;
    let feedBackModel = new Feedback(this.candidateArrya, this.feedback, this.status);
    this.updateFeedback(this.panelId, feedBackModel);
    // window.location.reload();
    this.notificationService.success('Feedback Submitted Successfully');    
}
    
  updateFeedback(panelId, feedback: Feedback): Promise<Array<Feedback>> {
    let feedbackHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId + "/feedback", JSON.stringify(feedback), { headers: feedbackHeaders })
      .toPromise()
      .then(response => response.json() as Feedback[])
      .catch(this.handleError);
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if (errorJSON.httpCode == 401) {
        ApiService.clearSessionObject();
      }
      return Promise.reject(errorJSON);
    } catch (err) {
      return Promise.reject(error && error.message);
    }
  }
}